import angular from 'angular';
import {populateTemplateCache} from './template-cache-loader';

// Load all our Angular HTML templates into $templateCache
angular.module('app').run(populateTemplateCache);
